import React from "react";
import Avatar from "@mui/material/Avatar";
import { useLocation } from "react-router-dom";

const UserProfile = () => {
  const location = useLocation();
  const profileData = location.state?.profile;

  if (!profileData) {
    return (
      <div style={{
        flex: 1,
        minHeight: "100vh",
        backgroundColor: "#374151",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "18px",
      }}>
        No profile data found.
      </div>
    );
  }

  return (
    <div style={{
      flex: 1,
      minHeight: "100vh",
      backgroundColor: "#374151",
      color: "white",
      padding: "24px 16px",
      boxSizing: "border-box",
      overflowX: "hidden",
    }}>

      {/* ✅ PROFILE CARD */}
      <div style={{
        backgroundColor: "#1f2937",
        borderRadius: "16px",
        padding: "24px",
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        maxWidth: "900px",
        width: "100%",
        boxSizing: "border-box",
      }}>

        {/* ✅ AVATAR */}
        <div style={{ display: "flex", alignItems: "center", gap: "20px", flexWrap: "wrap" }}>
          <Avatar
            variant="rounded"
            src={profileData.imageUrl}
            alt={profileData.name}
            sx={{ width: 120, height: 120, borderRadius: 4, flexShrink: 0 }}
          />
          <div>
            <h2 style={{ margin: 0, fontSize: "clamp(1.25rem, 4vw, 1.8rem)", fontWeight: 700, color: "white" }}>
              {profileData.name}
            </h2>
            <p style={{ margin: "4px 0 0 0", fontSize: "14px", color: "#9ca3af" }}>
              {profileData.email}
            </p>
          </div>
        </div>

        {/* ✅ FORM FIELDS — side by side on desktop, stacked on mobile */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
          gap: "20px",
        }}>

          {/* Username */}
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <label style={{
              fontSize: "13px",
              color: "#9ca3af",
              textTransform: "capitalize",
              fontWeight: 500,
            }}>
              Username
            </label>
            <input
              type="text"
              defaultValue={profileData.name}
              style={{
                width: "100%",
                padding: "12px 16px",
                borderRadius: "8px",
                border: "none",
                outline: "none",
                backgroundColor: "#374151",
                color: "#d1d5db",
                fontSize: "15px",
                boxSizing: "border-box",
                fontFamily: "inherit",
              }}
            />
          </div>

          {/* Email */}
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <label style={{
              fontSize: "13px",
              color: "#9ca3af",
              textTransform: "capitalize",
              fontWeight: 500,
            }}>
              Email
            </label>
            <input
              type="text"
              defaultValue={profileData.email}
              style={{
                width: "100%",
                padding: "12px 16px",
                borderRadius: "8px",
                border: "none",
                outline: "none",
                backgroundColor: "#374151",
                color: "#d1d5db",
                fontSize: "15px",
                boxSizing: "border-box",
                fontFamily: "inherit",
              }}
            />
          </div>

          {/* Phone — if exists */}
          {profileData.phone && (
            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <label style={{ fontSize: "13px", color: "#9ca3af", textTransform: "capitalize", fontWeight: 500 }}>
                Phone
              </label>
              <input
                type="text"
                defaultValue={profileData.phone}
                style={{ width: "100%", padding: "12px 16px", borderRadius: "8px", border: "none", outline: "none", backgroundColor: "#374151", color: "#d1d5db", fontSize: "15px", boxSizing: "border-box", fontFamily: "inherit" }}
              />
            </div>
          )}

          {/* UID */}
          {profileData.uid && (
            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <label style={{ fontSize: "13px", color: "#9ca3af", textTransform: "capitalize", fontWeight: 500 }}>
                User ID
              </label>
              <input
                type="text"
                defaultValue={profileData.uid}
                readOnly
                style={{ width: "100%", padding: "12px 16px", borderRadius: "8px", border: "none", outline: "none", backgroundColor: "#374151", color: "#6b7280", fontSize: "13px", boxSizing: "border-box", fontFamily: "monospace", cursor: "not-allowed" }}
              />
            </div>
          )}
        </div>

        {/* ✅ STATUS BADGES */}
        <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
          {profileData.isBlocked && (
            <span style={{ padding: "6px 14px", borderRadius: "20px", backgroundColor: "#dc2626", color: "white", fontSize: "13px", fontWeight: 600 }}>
              🚫 Blocked
            </span>
          )}
          {profileData.isSubscribed && (
            <span style={{ padding: "6px 14px", borderRadius: "20px", backgroundColor: "#d97706", color: "white", fontSize: "13px", fontWeight: 600 }}>
              ⭐ Prime Member
            </span>
          )}
          {!profileData.isBlocked && !profileData.isSubscribed && (
            <span style={{ padding: "6px 14px", borderRadius: "20px", backgroundColor: "#374151", border: "1px solid #4b5563", color: "#9ca3af", fontSize: "13px" }}>
              Standard User
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserProfile;